/**
 * サイト運営者がサイトのスタイルを変更したい場合にこのファイルを編集する。
 * 最終的にWordPressの管理画面から変更できるようにしたい項目。
 */
export const COLORS = {
  /**
   * サイトのbackgroundカラー
   */
  backColor: "#282c34",
};
export const HEADER_STYLE = {
  /**
   * ヘッダーのメインメッセージのFontSize
   */
  headerMessageFontSize: 30,
  /**
   * ヘッダーのメインメッセージのFontFamily
   */
  headerMessageFontFamily: "Lemonada",
};
/**
 * プロフィールのスタイル
 */
export const PROFILE_STYLE = {
  /**
   * プロフィール
   */
  profileFont: "Lemonada",
};
/**
 * サイドバーコンテンツデザイン
 */
export const SIDEBAR_COMMON_STYLE = {
  mainColor: "#87ceeb",
  color: "white",
  headerFontSize: 18,
};

/**
 * Aboutページデザイン
 */
export const ABOUT_STYLE = {
  mainColor: "#87ceeb",
  mainFont: "Lemonada",
};
